// extracted by mini-css-extract-plugin
export default {"wrapper":"SGa8pyv","title":"gECRlpk","workingIcon":"bxlgfxi"};